import { staffInboxPageSchema, } from "@lafayette/schemas";
import { createHandoffTransport, } from "./staff-handoffs";
export function createStaffInboxApi(options) {
    const send = createHandoffTransport(options, "the inbox API refused the request");
    return {
        list(input, callOptions) {
            const query = new URLSearchParams({ filter: input.filter });
            if (input.cursor !== undefined)
                query.set("cursor", input.cursor);
            if (input.limit !== undefined)
                query.set("limit", String(input.limit));
            return send({
                method: "GET",
                path: "staff/inbox",
                query,
                schema: staffInboxPageSchema,
                signal: callOptions?.signal,
            });
        },
    };
}
